import { render, staticRenderFns } from "./settingUser.vue?vue&type=template&id=1f6780bb&scoped=true&"
import script from "./settingUser.vue?vue&type=script&lang=js&"
export * from "./settingUser.vue?vue&type=script&lang=js&"
import style0 from "./settingUser.vue?vue&type=style&index=0&id=1f6780bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6780bb",
  null
  
)

export default component.exports